import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { AnessaTranslationService } from '../translation/anessa-translation.service';
import { takeUntil } from 'rxjs/operators';
import { UserpilotReloader } from '../userpilot-reloader.component';

@Component({
  selector: 'app-maintenance-mode',
  templateUrl: './maintenance-mode.component.html',
  styleUrls: ['./maintenance-mode.component.scss']
})
export class MaintenanceModeComponent extends UserpilotReloader implements OnInit, OnDestroy {
  private onDestroyNotifier = new EventEmitter();
  trigger?: string;

  constructor(private translationService: AnessaTranslationService) {
    super();
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(language => {
        this.trigger = language;
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }
}
